import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Button from '../Button';

const ErrorTitle = styled.p`
  font-weight: 700;
  font-size: 28px;
  text-align: center;
`;

const ErrorDescription = styled.p`
  font-weight: 600;
  font-size: 18px;
  text-align: center;
`;

const ErrorPageContainer = styled.div`
  display: flex;
  min-height: 50vh;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
`;

const LoadingErrorPage = () => {
  const { t } = useTranslation();

  return (
    <ErrorPageContainer>
      <ErrorTitle>{t('errorPage.title')}</ErrorTitle>
      <ErrorDescription>{t('errorPage.description')}</ErrorDescription>
      <Button
        outlined
        onClick={() => {
          window.location.reload();
        }}
      >
        {t('errorPage.btnCta')}
      </Button>
    </ErrorPageContainer>
  );
};

export default LoadingErrorPage;
